import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    css: css`
        position: absolute;
        right: 21px;
        ${xScreen("lte", "md")} {
            right: 0;
        }
    `,
};

ProductCompareCarouselStyles.navigationLink = {
    icon: { iconProps: { src: "ChevronLeft" } },
    typographyProps: { size: 12 },
    css: css`
        margin-top: 15px;
    `,
};
